import { render } from "./MfgFinishedProductStorage.vue?vue&type=template&id=036e55f6&scoped=true"
import script from "./MfgFinishedProductStorage.vue?vue&type=script&lang=js"
export * from "./MfgFinishedProductStorage.vue?vue&type=script&lang=js"

import "./MfgFinishedProductStorage.vue?vue&type=style&index=0&id=036e55f6&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036e55f6"]])

export default __exports__